import script from "./myprofile.vue?vue&type=script&setup=true&lang=js"
export * from "./myprofile.vue?vue&type=script&setup=true&lang=js"

import "./myprofile.vue?vue&type=style&index=0&id=7f4ce0f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f4ce0f2"]])

export default __exports__